import React, { useState } from "react"

import { Timer, TrendingUp } from "lucide-react"

import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs"

import RoutePerformance from "./data/RoutePerformance"
import WeekdayComparison from "./data/WeekdayComparison"

type DataTab = "weekday-comparison" | "route-performance"

const DataContent: React.FC = () => {
  const [activeSubTab, setActiveSubTab] = useState<DataTab>("route-performance")

  return (
    <div className="flex-1 flex flex-col min-h-0 overflow-hidden">
      <div className="bg-white border-b border-palette-jungleGreen200 px-6 py-1.5 flex-shrink-0">
        <Tabs value={activeSubTab} onValueChange={(v) => setActiveSubTab(v as DataTab)}>
          <TabsList className="bg-transparent h-8 p-0 gap-0.5">
            <TabsTrigger
              value="route-performance"
              className="data-[state=active]:bg-palette-jungleGreen100 data-[state=active]:text-palette-jungleGreen900 text-palette-jungleGreen500 gap-1.5 px-3 py-1 rounded text-xs font-medium"
            >
              <Timer size={12} />
              Route Performance
            </TabsTrigger>
            <TabsTrigger
              value="weekday-comparison"
              className="data-[state=active]:bg-palette-jungleGreen100 data-[state=active]:text-palette-jungleGreen900 text-palette-jungleGreen500 gap-1.5 px-3 py-1 rounded text-xs font-medium"
            >
              <TrendingUp size={12} />
              Weekday Comparison
            </TabsTrigger>
          </TabsList>
        </Tabs>
      </div>

      <div className="flex-1 flex flex-col min-h-0 overflow-hidden">
        {activeSubTab === "route-performance" && <RoutePerformance />}
        {activeSubTab === "weekday-comparison" && <WeekdayComparison />}
      </div>
    </div>
  )
}

export default DataContent
